<script>
    import R, {LOADER} from "../../lib/requests";
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";
    import {copyObjectProperties, sort} from "../../lib/lib";
    import {flip} from 'svelte/animate';
    import PageHeader from "../../components/PageHeader.svelte";
    import TableHeader from "../../components/TableHeader.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import AnalysisGroupEditModal from "./AnalysisGroupEditModal.svelte";
    import GroupAnalyses from "./GroupAnalyses.svelte";


    let list = null;
    let selectedId = 0;
    let editId = null;
    let group = null;
    let hovering = false;

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΟΜΑΔΑΣ', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    // const tableColumns = [
    //     {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true},
    //     {key: 'name', title: 'ΟΜΑΔΑ', sortable: true, sort_way: 'ASC'},
    //     {key: '', title: ''},
    //     {key: '', title: ''},
    // ];

    const tableColumns = [
        {key: 'name', title: 'ΟΜΑΔΑ'},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            list = result;
        }

        const onFailure = err => {
        };

        R.handle(R.analysisGroup.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const saveOrder = () => {

        const onSuccess = result => {
            Notifier.showMessage("Η σειρά εμφάνισης ενημερώθηκε.")
        }

        const onFailure = err => {
        };

        let ids = list.map(item => item.id);
        R.handle(R.analysisGroup.setOrder, ids, onSuccess, onFailure, LOADER.NONE);
    }

    const onSearchChange = () => {
        load();
    }

    const onColumnSort = ({detail}) => {
        list = sort(list, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (group) => {
        editId = group.id;
    }

    const onClick = (item) => {
        group = item;
        selectedId = item.id;
    }

    const closeEdit = (group) => {
        if (group) {
            let properties = ['id', 'code', 'name'];

            let item = list.find(x => x.id == group.id);
            if (item) {
                copyObjectProperties(group, item, properties);
                list = list;
            } else {
                list = [copyObjectProperties(group, properties), ...list];
            }
        }
        editId = null;
    }

    const closeGroupAnalyses = () => {
        group = null;
    }

    const onDelete = (item) => {
        Alert.delete("Διαγραφή ομάδας αναλύσεων", `Πρόκειται να διαγράψετε την ομάδα "${item.name}".\nΘέλετε να συνεχίσετε;`, () => deleteItem(item.id));
    }

    const deleteItem = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
            Notifier.showMessage("Η ομάδα διαγράφτηκε");
        }

        const onFailure = err => {

        };

        R.handle(R.analysisGroup.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    /* Drag drop handlers */
    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = list;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        list = newTracklist;
        hovering = null;
        saveOrder();
    }

    load();
</script>

<PageHeader title="Ομάδες Αναλύσεων" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if list}
    <div class="row">
        <div class="col-lg-4">
            <div class="panel">
                <div class="panel-body">
                    {#if list.length}
                        <table class="table table-list analyses-list table-list-border">
                            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                            <tbody>
                            {#each list as item, index (item.id)}
                                <tr class="row-hover" class:row-selected="{ selectedId === item.id }"
                                    animate:flip="{{ duration: 100 }}"
                                    draggable={true}
                                    on:dragstart={event => dragstart(event, index)}
                                    on:drop|preventDefault={event => drop(event, index)}
                                    ondragover="return false"
                                    on:dragenter={() => hovering = index}
                                    class:drag-over={hovering === index}
                                >
<!--                                    <td class="code-column">-->
<!--                                        { item.code }-->
<!--                                    </td>-->
                                    <td>
                                        <span class="is-link"
                                              on:click="{ () => onClick(item) }">
                                            { item.name }
                                        </span>
                                    </td>
                                    <td class="button-column pointer" title="επεξεργασία ομάδας"
                                        on:click="{ () => onEdit(item) }">
                                        <AppIcon icon="edit" size="16"/>
                                    </td>
                                    <td class="button-column pointer" title="διαγραφή ομάδας"
                                        on:click="{ () => onDelete(item) }">
                                        <AppIcon icon="trash" size="16"/>
                                    </td>
                                </tr>
                            {/each}
                            </tbody>
                        </table>
                    {/if}
                </div>
            </div>
        </div>
        <div class="col-lg-8">
            {#if group != null}
                <GroupAnalyses {group} closeCallback="{ closeGroupAnalyses }"/>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <AnalysisGroupEditModal groupId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

<style>
    .analyses-list .code {
        width: 60px;
    }

    .panel-filters {
        background: #fff;
        border: var(--default-border);
    }

    .panel-filters .filter-row {
        display: flex;
    }

    .panel-filters .filter-col-group {
        display: flex;
        width: 100%;
    }

    .panel-filters .filter-col {
        padding: 5px 10px;
    }

    .panel-filters .filter-col.user-name {
        width: 100%;
    }

    @media (max-width: 576px) {
        .panel-filters .filter-row {
            display: block;
        }

        .panel-filters .filter-col.border-after:after {
            border: none;
        }
    }
</style>